"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBreakpoint = exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getBreakpoint = function getBreakpoint() {
  if (typeof window === 'undefined') {
    return 'small';
  }

  var before = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content');
  return (before === null || before === void 0 ? void 0 : before.replace(/"/g, '')) || 'small';
};

var ResponsiveContext = /*#__PURE__*/(0, _react.createContext)({});

var ResponsiveProvider = function ResponsiveProvider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(getBreakpoint()),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      breakpoint = _useState2[0],
      setBreakpoint = _useState2[1];

  var handleWindowResize = (0, _debounce["default"])(function () {
    setBreakpoint(getBreakpoint());
  }, 300);
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', handleWindowResize);
    setBreakpoint(getBreakpoint());
    return function () {
      return window.removeEventListener('resize', handleWindowResize);
    };
  }, [handleWindowResize]);
  return /*#__PURE__*/_react["default"].createElement(ResponsiveContext.Provider, {
    value: {
      breakpoint: breakpoint
    }
  }, children);
};

ResponsiveProvider.propTypes = {
  children: _propTypes.node.isRequired
};

var useBreakpoint = function useBreakpoint() {
  var _useContext = (0, _react.useContext)(ResponsiveContext),
      breakpoint = _useContext.breakpoint;

  var isExtraLarge = breakpoint === 'extra-large';
  var isLarge = ['large', 'extra-large'].includes(breakpoint);
  var isMedium = ['medium'].includes(breakpoint);
  var isNotSmall = ['not-small', 'medium', 'large', 'extra-large'].includes(breakpoint);
  var isSmall = breakpoint === 'small';
  return {
    breakpoint: breakpoint,
    isExtraLarge: isExtraLarge,
    isLarge: isLarge,
    isMedium: isMedium,
    isNotSmall: isNotSmall,
    isSmall: isSmall
  };
};

exports.useBreakpoint = useBreakpoint;
ResponsiveProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ResponsiveProvider",
  "props": {
    "children": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": true
    }
  }
};
var _default = ResponsiveProvider;
exports["default"] = _default;